module.exports = __webpack_public_path__ + "themes/non-default/addeparStep2PortfolioName.6f5eff441b7a4f15e8a1e24359f809cc.png";